"use client";

import { useEffect, useState } from "react";
import { WifiOff, Wifi } from "lucide-react";

export default function NetworkStatus() {
  const [isOnline, setIsOnline] = useState(true);
  const [showStatus, setShowStatus] = useState(false);

  useEffect(() => {
    const updateOnlineStatus = () => {
      const online = navigator.onLine;
      setIsOnline(online);
      setShowStatus(true);

      // Auto-hide after 3 seconds
      setTimeout(() => setShowStatus(false), 3000);
    };

    setIsOnline(navigator.onLine);

    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);

    return () => {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
    };
  }, []);

  if (!showStatus) return null;

  return (
    <div
      className={`fixed top-4 right-4 px-4 py-2 rounded-lg flex items-center gap-2 transition-all ${
        isOnline ? "bg-green-500" : "bg-red-500"
      } text-white shadow-lg z-50`}
    >
      {isOnline ? (
        <>
          <Wifi className="w-4 h-4" />
          <span>Đã kết nối mạng</span>
        </>
      ) : (
        <>
          <WifiOff className="w-4 h-4" />
          <span>Mất kết nối mạng</span>
        </>
      )}
    </div>
  );
}